const routes = [
  {
    path: '/',
    name: 'ServiceMain',
    component: () => import('@/layout/Service'),
    redirect: { name: 'OnsaleHomeLayout'},
    children: [
      {
        path: 'onsaleHome/terms',
        name: 'onsaleHomeTerms',
        component: () => import('@/components/onsaleHome/Terms')
      },
      {
        path: 'onsaleHome/rules',
        name: 'onsaleHomeRules',
        component: () => import('@/components/onsaleHome/Rules')
      },
      {
        path: 'onsaleHome',
        name: 'OnsaleHomeLayout',
        component: () => import('@/layout/OnsaleHome'),
        redirect: { name: 'OnsaleHome'},
        children: [
          {
            path: '',
            name: 'OnsaleHome',
            component: () => import('@/components/onsaleHome')
          },
          {
            path: 'step1',
            name: 'OnsaleHomeStep1',
            component: () => import('@/components/onsaleHome/step1')
          },
          {
            path: 'step2',
            name: 'OnsaleHomeStep2',
            component: () => import('@/components/onsaleHome/step2_new')
          },
          {
            path: 'auth-popup',
            name: 'OnsaleHomeAuthPopup',
            component: () => import('@/components/onsaleHome/popup/AuthPopup')
          }
        ]
      },

      {
        path: 'auth-popup',
        name: 'AuthPopupLayout',
        component: () => import('@/layout/AuthPopupLayout'),
        children: [
          {
            path: 'ipin-auth-popup',
            name: 'CallIpinAuthPop',
            component: () => import('@/components/popup/CallIpinAuthPop')
          },
          {
            path: 'ipin-auth-result',
            name: 'ResultIpinAuthPop',
            component: () => import('@/components/popup/ResultIpinAuthTpsPop')
          },
          {
            path: 'normal-auth-popup',
            name: 'CallNormalAuthPop',
            component: () => import('@/components/popup/CallNormalAuthPop')
          },
          {
            path: 'normal-auth-result',
            name: 'ResultNormalAuthPop',
            component: () => import('@/components/popup/ResultNormalAuthPop')
          },
          {
            path: 'kmc-auth-popup',
            name: 'CallKmcAuthPop',
            component: () => import('@/components/popup/CallKmcAuthPop')
          },
          {
            path: 'kmc-auth-result',
            name: 'ResultKmcAuthPop',
            component: () => import('@/components/popup/ResultKmcAuthPop')
          },
          {
            path: 'kcb-auth-popup',
            name: 'CallKcbAuthPop',
            component: () => import('@/components/popup/CallKcbAuthPop')
          },
          {
            path: 'kcb-auth-result',
            name: 'ResultKcbAuthPop',
            component: () => import('@/components/popup/ResultKcbAuthPop')
          },
          {
            path: 'kmc-tps-result',
            name: 'ResultKmcTpsPop',
            component: () => import('@/components/popup/ResultKmcTpsPop')
          }
        ]
      }
    ]
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/components/ErrorPage')
  },
  {
    path: '/jsp/sqr/rqst/common/popup_cellphone_auth_kmc.jsp',
    name: 'AfterActivationRedirectPage',
    component: () => import('@/components/afterActivation/RedirectPage')
  },
  {
    path: '/CounselApplicationNewFormCmd.uplus',
    name: 'SimpleCounselRedirectPage',
    component: () => import('@/components/simpleCounsel/RedirectPage')
  },
  {
    path: '/SusAppFormUserTypeCmd.uplus',
    name: 'OpenMarketRedirectPage',
    component: () => import('@/components/openMarket/RedirectPage')
  },
  {
    path: '/IndexCmd.uplus',
    name: 'OpenMarketExistingRegistrationRedirectPage',
    component: () => import('@/components/openMarket/existingRegistration/RedirectPage')
  },
  {
    path: '/CarAppFormUserTypeCmd.uplus',
    name: 'ConnectedCarRedirectPage',
    component: () => import('@/components/connectedCar/RedirectPage')
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/components/NotFound')
  },
  {
    path: '/mrc/kr/cust/svcapp/online/Main.jsp',
    name: 'onsaleHomeRedirectPage',
    component: () => import('@/components/onsaleHome/RedirectPage')
  },
  {
    path: '/mrc/kr/cust/svcapp/online/ApplyForm.jsp',
    name: 'onsaleHomeRedirectPage',
    component: () => import('@/components/onsaleHome/RedirectPage')
  },
  
]

export { routes }
  